import { useState } from "react";
import { context } from "./context";
import { withRouter, useHistory } from "react-router";
import {
  checkEmail,
  checkMobileNum,
  checkValidOfRepeat,
  checkMinimumPass,
} from "../components/Validator/Validator";
import {
  ERROR_CODE1,
  ERROR_CODE2,
  ERROR_CODE3,
  ERROR_CODE4,
  ERROR_CODE5,
} from "../components/Validator/ErrorCodes";

const AuthUserContext = ({ children }) => {
  const history = useHistory();
  //All States
  //For Login
  const [userEmail, setUserEmail] = useState("");
  const [userNumber, setUserNumber] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [validatorLogin, setValidatorLogin] = useState({
    number: "",
    email: "",
  });
  //

  //For Register
  const [newUserEmail, setNewUserEmail] = useState("");
  const [newUserNumber, setNewUserNumber] = useState("");
  const [newReferral, setNewReferral] = useState("");
  const [verifyCodeRegister, setVerifyCodeRegister] = useState("");
  const [registerAccSteps, setRegisterAccSteps] = useState({
    showVerifyCode: false,
    activeSetPassword: false,
  });
  ///> > > Finally Registration "REGISTER SECTION"
  const [newUserPassword, setNewUserPassword] = useState("");
  const [repeatNewUserPassword, setRepeatNewUserPassword] = useState("");
  const [validatorRegister, setValidatorRegister] = useState({
    number: "",
    email: "",
    verifyCode: "",
    password: "",
    repeatPassword: "",
  });
  //

  //For Recovery Account
  const [numRecovery, setNumRecovery] = useState("");
  const [emailRecovery, setEmailRecovery] = useState("");
  const [verifyCodeRecovery, setVerifyCodeRecovery] = useState();
  const [recoveryAccSteps, setRecoveryAccSteps] = useState({
    showVerifyCode: false,
    showNewPassword: false,
  });
  // > > > For Add New PassWord in "RECOVERY SECTION"
  const [changePassword, setChangePassword] = useState("");
  const [repeatChangePassword, setRepeatChangePassword] = useState("");
  const [validatorRecovery, setValidatorRecovery] = useState({
    number: "",
    email: "",
    verifyCode: "",
    password: "",
    repeatPassword: "",
  });
  //

  //For check URL's
  //Cleared, OPTIMIZED APPLICATION
  //

  const handleLoginNumber = async (event) => {
    event.preventDefault();
    let isValidNumber = await checkMobileNum(userNumber);
    if (!isValidNumber)
      return setValidatorLogin({ ...validatorLogin, number: ERROR_CODE1 });
    try {
      alert("Hello");
    } catch (ex) {
      console.log(ex);
    }
  };
  const handleLoginEmail = async (event) => {
    event.preventDefault();
    let isValidEmail = await checkEmail(userEmail);
    if (!isValidEmail)
      return setValidatorLogin({ ...validatorLogin, email: ERROR_CODE2 });
    try {
      alert("Hello");
    } catch (ex) {
      console.log(ex);
    }
  };
  //Registration Functions
  const handleRegisterNum = async (event) => {
    event.preventDefault();
    let isValidNumber = await checkMobileNum(newUserNumber);
    if (!isValidNumber)
      return setValidatorRegister({
        ...validatorRegister,
        number: ERROR_CODE1,
      });
    try {
      console.log("Hello");
      setRegisterAccSteps({ ...registerAccSteps, showVerifyCode: true });
    } catch (ex) {
      console.log(ex);
    }
  };
  const handleRegisterEmail = async (event) => {
    event.preventDefault();
    let isValidEmail = await checkEmail(newUserEmail);
    if (!isValidEmail)
      return setValidatorRegister({ ...validatorRegister, email: ERROR_CODE2 });
    try {
      setRegisterAccSteps({ ...registerAccSteps, showVerifyCode: true });
      alert("Hello");
    } catch (ex) {
      console.log(ex);
    }
  };
  const handleRegisterCodeVerify = async (value) => {
    try {
      if (value) {
        console.log(value);
        setRegisterAccSteps({ ...registerAccSteps, activeSetPassword: true });
      } else {
        setValidatorRegister({ ...validatorRegister, verifyCode: ERROR_CODE5 });
      }
    } catch (ex) {
      console.log(ex);
    }
  };
  const handleNewUserCompleteRegistration = async (e) => {
    e.preventDefault();
    let isMinPass = await checkMinimumPass(newUserPassword);
    if (!isMinPass)
      return setValidatorRegister({
        ...validatorRegister,
        password: ERROR_CODE3,
      });
    let checkRepeatPass = checkValidOfRepeat(
      newUserPassword,
      repeatNewUserPassword
    );
    if (!checkRepeatPass)
      return setValidatorRegister({
        ...validatorRegister,
        repeatPassword: ERROR_CODE4,
      });
    try {
      console.log("success");
    } catch (ex) {
      console.log(ex);
    }
  };

  //Recovery Handle Functions
  const handleRecoveryNum = async (event) => {
    event.preventDefault();
    let isValidNumber = await checkMobileNum(numRecovery);
    if (!isValidNumber)
      return setValidatorRecovery({
        ...validatorRecovery,
        number: ERROR_CODE1,
      });
    try {
      setRecoveryAccSteps({
        ...recoveryAccSteps,
        showVerifyCode: true,
      });
    } catch (ex) {
      console.log(ex);
    }
  };
  const handleRecoveryEmail = async (event) => {
    event.preventDefault();
    let isValidEmail = await checkEmail(emailRecovery);
    if (!isValidEmail)
      return setValidatorRecovery({ ...validatorRecovery, email: ERROR_CODE2 });
    try {
      setRecoveryAccSteps({
        ...recoveryAccSteps,
        showVerifyCode: true,
      });
    } catch (ex) {
      console.log(ex);
    }
  };
  const handleVerifyCodeRecovery = async (event) => {
    event.preventDefault();
    //HERE we send verify code with services to API if valid Continue the progress...
    // (verifyCodeRecovery => STATE)
    if (!verifyCodeRecovery || verifyCodeRecovery.length !== 6) {
      return;
    } //This will be removed after -dev
    try {
      setRecoveryAccSteps({
        ...recoveryAccSteps,
        showVerifyCode: false,
        showNewPassword: true,
      });
      console.log("data send");
    } catch (ex) {
      console.log(ex);
    }
  };
  const handleChangeUserPassword = async (event) => {
    event.preventDefault();
    let isMinPass = await checkMinimumPass(changePassword);
    if (!isMinPass)
      return setValidatorRecovery({
        ...validatorRecovery,
        password: ERROR_CODE3,
      });
    let checkRepeatPass = checkValidOfRepeat(
      changePassword,
      repeatChangePassword
    );
    if (!checkRepeatPass)
      return setValidatorRecovery({
        ...validatorRecovery,
        repeatPassword: ERROR_CODE4,
      });
    try {
      setRecoveryAccSteps({
        ...recoveryAccSteps,
        showVerifyCode: false,
        showNewPassword: false,
      });
      history.replace("/authorization/login");
      console.log("data send");
    } catch (ex) {
      console.log(ex);
    }
  };

  return (
    <context.Provider
      value={{
        //State of Login User
        userEmail,
        userNumber,
        userPassword,
        newUserEmail,
        newUserNumber,
        numRecovery,
        changePassword,
        newReferral,
        emailRecovery,
        recoveryAccSteps,
        verifyCodeRecovery,
        repeatChangePassword,
        registerAccSteps,
        newUserPassword,
        repeatNewUserPassword,
        verifyCodeRegister,
        setVerifyCodeRegister,
        setNewUserPassword,
        setRepeatNewUserPassword,
        handleNewUserCompleteRegistration,
        setRegisterAccSteps,
        setRepeatChangePassword,
        setVerifyCodeRecovery,
        setRecoveryAccSteps,
        setEmailRecovery,
        setNewReferral,
        setUserPassword,
        setUserEmail,
        setUserNumber,
        setNewUserEmail,
        setNumRecovery,
        setNewUserNumber,
        setChangePassword,
        handleLoginNumber,
        handleLoginEmail,
        handleRegisterNum,
        handleRegisterEmail,
        handleRecoveryNum,
        handleRecoveryEmail,
        handleVerifyCodeRecovery,
        handleRegisterCodeVerify,
        handleChangeUserPassword,
        //This bottom props for handle errors ''
        validatorLogin,
        setValidatorLogin,
        validatorRegister,
        setValidatorRegister,
        validatorRecovery,
        setValidatorRecovery,
      }}
    >
      {children}
    </context.Provider>
  );
};
export default withRouter(AuthUserContext);
